import { forwardRef, type Ref, type SVGProps } from "react";
const IconVideoCameraOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="m29.1 8-.8.2-2.6 1.6a4 4 0 0 0-1.7 3v6.4a4 4 0 0 0 1.7 3l2.6 1.6.8.2c.5 0 .9-.4.9-1.2V9.2c0-.8-.4-1.2-.9-1.2M28 21.2l-1.3-.7a2.1 2.1 0 0 1-.7-1.3v-6.4a2.1 2.1 0 0 1 .7-1.3l1.3-.7zM20.8 7H3.2A1.2 1.2 0 0 0 2 8.2v15.6A1.2 1.2 0 0 0 3.2 25h17.6a1.2 1.2 0 0 0 1.2-1.2V8.2A1.2 1.2 0 0 0 20.8 7M20 23H4V9h16z"
    />
    <path
      fill="currentColor"
      d="M12 11a5 5 0 1 0 5 5 5 5 0 0 0-5-5m0 8a3 3 0 1 1 3-3 2.9 2.9 0 0 1-3 3"
    />
  </svg>
);
const ForwardRef = forwardRef(IconVideoCameraOutlineSVG);
ForwardRef.displayName = "IconVideoCameraOutline";
export { ForwardRef as IconVideoCameraOutline };
